import { BiSolidQuoteAltLeft } from "react-icons/bi";

const BlogDetailArticleSection = ({ blogData }) => {
  return (
    <>
      <article className="max-w-4xl mx-auto flex flex-col gap-y-5">
        <h1 data-aos="fade-up" data-aos-duration="700" className="familjen-font text-3xl md:text-4xl font-semibold mb-4">
          {blogData?.title}
        </h1>
        <div data-aos="fade-up" data-aos-duration="700" className="text-justify text-gray-700 leading-relaxed space-y-4">
          <span className="float-left text-4xl font-bold bg-[#0BB6D9] text-white px-3 py-1 rounded-md mr-3 flex items-center justify-center w-[2.5rem] h-[3rem]">
            {blogData?.description?.charAt(0)}
          </span>
          {blogData?.description?.slice(1)}
        </div>
        {blogData?.subDescriptions?.map((text, index) => (
          <p data-aos="fade-up" data-aos-duration="700" key={index} className="text-gray-700 text-justify">
            {text}
          </p>
        ))}
      </article>
      <blockquote data-aos="fade-up" data-aos-duration="700" className="bg-black text-xl gap-y-3 rounded-3xl p-10 flex flex-col items-center justify-center text-white text-center">
        <span className="md:text-9xl text-7xl">
          <BiSolidQuoteAltLeft />
        </span>
        <p data-aos="fade-up" data-aos-duration="700">"{blogData?.quote?.text}"</p>
        <span data-aos="fade-up" data-aos-duration="700" className="font-bold underline">{blogData?.quote?.title}</span>
      </blockquote>
      <article className="text-[#4f4f4f] flex flex-col gap-y-5">
        <h1 data-aos="fade-up" data-aos-duration="700" className="familjen-font font-bold capitalize text-3xl text-black">
          {blogData?.feature?.heading}
        </h1>
        <p data-aos="fade-up" data-aos-duration="700">{blogData?.feature?.description}</p>
        {blogData?.feature?.subDescriptions?.map((text, index) => (
          <p key={index}>{text}</p>
        ))}
      </article>
    </>
  );
};

export default BlogDetailArticleSection;